var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 9,
    viewBox: "0 0 77 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M76.3536 4.85355C76.5488 4.65829 76.5488 4.34171 76.3536 4.14645L73.1716 0.964466C72.9763 0.769204 72.6597 0.769204 72.4645 0.964466C72.2692 1.15973 72.2692 1.47631 72.4645 1.67157L75.2929 4.5L72.4645 7.32843C72.2692 7.52369 72.2692 7.84027 72.4645 8.03553C72.6597 8.2308 72.9763 8.2308 73.1716 8.03553L76.3536 4.85355ZM0 5H76V4H0V5Z",
    fill: "#11302D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.c6cfec08ac7526e1adc349398e85ff13.svg";
export { ForwardRef as ReactComponent };